// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"5f7bfa38","451":"1f6d55ce","453":"8d27e589","840":"bd3bbbf0"}[chunkId] + ".chunk.js";
};